import vkIcon from '@ucheba/ui/icons/icon__vk_square.svg'
import instagramIcon from '@ucheba/ui/icons/icon__instagram_square.svg'
import { EIconName, IUseFeedbackListWithIcons, TIconName } from './types'

export const useFeedbackListWithIcons: IUseFeedbackListWithIcons = (list) => {
  const Icon = (iconName: TIconName): string => {
    switch (iconName) {
      case EIconName.vk:
        return vkIcon
      case EIconName.instagram:
        return instagramIcon
      default:
        return ''
    }
  }

  return list.map((el) => ({ ...el, Icon: Icon(el.socials?.type as TIconName) }))
}
